import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';

export interface IMenuLeftProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
}
export default class MenuLeftPage extends React.Component<IMenuLeftProps> {
  render() {
    return (
      <div id="menuLeft">
        <Nav vertical>
          <NavItem style={{ marginTop: '10px' }}>
            <NavLink style={{ color: 'white' }} href="/admin">
              Quản trị danh tính Công dân
            </NavLink>
            <hr className="hr" />
          </NavItem>
          {this.props.isAdmin && this.props.isAuthenticated ? (
            <NavItem>
              <NavLink style={{ color: 'white' }} href="/admin/manager">
                Quản trị admin
              </NavLink>
              <hr className="hr" />

              <NavLink style={{ color: 'white' }} href="/admin/vinaInfo">
                Tra cứu thông tin nhà mạng
              </NavLink>
              <hr className="hr" />
            </NavItem>
          ) : null}

          {window.innerWidth <= 414 ? (
            <NavItem>
              <NavLink style={{ color: 'white' }} href="/admin/info">
                Thông tin tài khoản
              </NavLink>
              <hr className="hr" />

              <NavLink style={{ color: 'white' }} href="/logout">
                Đăng xuất
              </NavLink>
            </NavItem>
          ) : null}
        </Nav>
      </div>
    );
  }
}
